var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpResponse } from '@bolteu/http-client';
import { HttpResponseErrorBoltServer, HttpResponseErrorTypeBoltServer, } from './HttpResponseErrorBoltServer';
import { HttpResponseUtilsBoltServer } from './HttpResponseUtilsBoltServer';
var HttpResponseNormalizerBoltServer = /** @class */ (function () {
    function HttpResponseNormalizerBoltServer() {
    }
    HttpResponseNormalizerBoltServer.prototype.normalize = function (response, request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!HttpResponseUtilsBoltServer.isBoltServerResponse(response)) {
                    if (response.status >= 400) {
                        throw new HttpResponseErrorBoltServer.HttpStatusError(response);
                    }
                    // Ignore successful non-bolt responses, so raw endpoints that doesn't look like standard will work
                    return [2 /*return*/, response];
                }
                if (response && HttpResponseUtilsBoltServer.isOk(response)) {
                    return [2 /*return*/, new HttpResponse(response.status, response.headers, response.body.data)];
                }
                throw this.createError(response, request);
            });
        });
    };
    HttpResponseNormalizerBoltServer.prototype.createError = function (response, request) {
        if (response && HttpResponseUtilsBoltServer.isValidationError(response)) {
            return new HttpResponseErrorBoltServer.ValidationError(response.body.validation_errors);
        }
        if (response && HttpResponseUtilsBoltServer.isMissingEntityError(response)) {
            return new HttpResponseErrorBoltServer.EntityNotFoundError(request.url.toString(), response.body.error_data);
        }
        if (response && HttpResponseUtilsBoltServer.isLegacyMissingPermissionsError(response)) {
            return this.createMissingPermissionsErrorFromLegacy(response.body);
        }
        if (response && HttpResponseUtilsBoltServer.isMissingPermissionsError(response)) {
            return new HttpResponseErrorBoltServer.MissingPermissionsError(response.body.error_data.type, response.body.error_data.permissions);
        }
        if (response && HttpResponseUtilsBoltServer.isJwtTokenExpiredError(response)) {
            return new HttpResponseErrorBoltServer.AuthTokenExpiredError(response.body.error_data.expiredAt);
        }
        return new HttpResponseErrorBoltServer.ServerResponseError(response.body, request.url.toString());
    };
    HttpResponseNormalizerBoltServer.prototype.createMissingPermissionsErrorFromLegacy = function (response) {
        if (response.error_data.requiredOneOfPermissions) {
            return new HttpResponseErrorBoltServer.MissingPermissionsError(HttpResponseErrorTypeBoltServer.PermissionMissingType.ONE_OF, response.error_data.requiredOneOfPermissions);
        }
        var permissions = [];
        if (response.error_data.requiredPermission) {
            permissions = [response.error_data.requiredPermission];
        }
        if (response.error_data.requiredPermissions) {
            permissions = response.error_data.requiredPermissions;
        }
        return new HttpResponseErrorBoltServer.MissingPermissionsError(HttpResponseErrorTypeBoltServer.PermissionMissingType.ALL, permissions);
    };
    return HttpResponseNormalizerBoltServer;
}());
export { HttpResponseNormalizerBoltServer };
